import { IFeatures } from '@bciti/types';
import { Observable } from 'rxjs';
import { PatchConfigurationPayload } from '../configuration/configuration.service';

export abstract class FeaturesService {
    abstract getFeatures(orgTag: string): Observable<IFeatures>;
    abstract updateFeatures(orgTag: string, features: IFeatures): Observable<IFeatures>;
    abstract createFeatures(orgTag: string, features: IFeatures): Observable<IFeatures>;
    abstract generatePayload(features: IFeatures): PatchConfigurationPayload;
}
